BaseStore = require './BaseStore'
ActionTypes = require 'constants/ActionTypes'
AuthStore = require './AuthStore'


class AgentsAssignStore extends BaseStore
  constructor: ->
    super()
    @agents = {}
    @list = []
    @loading = false
    @registerActions()

  _registerToActions: ({ type, payload }) =>
    switch type
      when ActionTypes.MQTT_ASSIGN_USERS_REQUEST
        @agents = {}
        @list = []
        @loading = true
        @emitChange()
      when ActionTypes.MQTT_ASSIGN_USERS_UPDATING_INITIAL
        @agents = {}
        @list = []
        @loading = true
        @emitChange()
      when ActionTypes.MQTT_ASSIGN_USERS_UPDATING
        Object.keys(payload.message).forEach (id) =>
          if payload.message[id]
            @agents[id] ||= {}
            Object.keys(payload.message[id]).forEach (key) =>
              @agents[id][key] = payload.message[id][key]
            delete @agents[id] unless @agents[id].id
          else
            delete @agents[id]
        @list = Object.keys(@agents).map (id) =>
          @agents[id]
        @loading = false if payload.initial
        @emitChange()

module.exports = new AgentsAssignStore()
